import {
  NoContentContainer,
  Table,
  TableCell,
  TableContainer,
  TableRow,
} from "@/components/Table";
import { safeNumber } from "@/utils/number";
import { IconButton, Typography } from "@mui/material";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import { useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import { ResultOf, graphql } from "@/config/graphql";

export const currentProductionDetails = graphql(`
  query currentProductionDetails($params: ReportParams!) {
    report(params: $params) {
      id
      batchControlDetails {
        id
        initialHourometer
        finalHourometer
        waste
      }
    }
  }
`);
interface BatchControlTableProps {
  onEdit?: (
    detail: NonNullable<
      ResultOf<typeof currentProductionDetails>["report"]["batchControlDetails"]
    >[number]
  ) => void;
}
export const BatchControlTable = (props: BatchControlTableProps) => {
  const params = useParams();
  const { data } = useQuery(currentProductionDetails, {
    variables: { params: { id: +(params.id || 0) } },
    fetchPolicy: "cache-only",
  });
  const totalHours =
    data?.report?.batchControlDetails?.reduce(
      (acc, detail) =>
        acc +
        (safeNumber(detail.finalHourometer) -
          safeNumber(detail.initialHourometer)),
      0
    ) ?? 0;
  const totalWaste =
    data?.report?.batchControlDetails?.reduce(
      (acc, detail) => acc + safeNumber(detail.waste),
      0
    ) ?? 0;
  return (
    <TableContainer>
      <Table>
        <thead>
          <TableRow variant="mainHeader">
            <TableCell sx={{ minWidth: 40 }}></TableCell>
            <TableCell># Partida</TableCell>
            <TableCell>Horómetro inicial</TableCell>
            <TableCell>Horómetro final</TableCell>
            <TableCell>Horas</TableCell>
            <TableCell>Pérdida (ton)</TableCell>
          </TableRow>
        </thead>
        <tbody>
          {data?.report?.batchControlDetails?.map((detail, index) => {
            return (
              <TableRow key={index} onClick={() => props.onEdit?.(detail)}>
                <TableCell>
                  {props.onEdit ? (
                    <IconButton
                      sx={{
                        color: "#333333",
                        padding: 0,
                        width: 24,
                        height: 24,
                      }}
                    >
                      <CreateOutlinedIcon />
                    </IconButton>
                  ) : null}
                </TableCell>
                <TableCell textAlign="center">{index + 1}</TableCell>
                <TableCell textAlign="center">
                  {detail.initialHourometer?.toLocaleString("es-CL")}
                </TableCell>
                <TableCell textAlign="center">
                  {detail.finalHourometer?.toLocaleString("es-CL")}
                </TableCell>
                <TableCell textAlign="center">
                  {(
                    safeNumber(detail.finalHourometer) -
                    safeNumber(detail.initialHourometer)
                  ).toLocaleString("es-CL")}
                </TableCell>
                <TableCell textAlign="center">
                  {detail.waste?.toLocaleString("es-CL")}
                </TableCell>
              </TableRow>
            );
          })}
          {Boolean(data?.report.batchControlDetails?.length) && (
            <TableRow>
              <TableCell></TableCell>
              <TableCell textAlign="center"></TableCell>
              <TableCell textAlign="center"></TableCell>
              <TableCell textAlign="center">
                <Typography fontWeight={600}>Total</Typography>
              </TableCell>
              <TableCell textAlign="center">
                {totalHours.toLocaleString("es-CL")}
              </TableCell>
              <TableCell textAlign="center">
                {totalWaste.toLocaleString("es-CL")}
              </TableCell>
            </TableRow>
          )}
        </tbody>
      </Table>
      {data?.report.batchControlDetails?.length === 0 && (
        <NoContentContainer>
          <Typography variant="body2">No hay partidas declaradas</Typography>
        </NoContentContainer>
      )}
    </TableContainer>
  );
};
